<template lang="pug">
  span.password-rules
    b-button.btn.btn-outline-info.btn-info.btn-sm(
      type="button"
      :style="buttonStyle"
      :title="$t('ui.password_rules')"
      :aria-label="$t('ui.password_rules')"
      @click="show = true"
    )
      i.fa.fa-info-circle(aria-hidden="true")
    b-modal(
      v-model="show"
      :title="$t('ui.password_rules')"
      centered
      no-fade
      hide-footer
      size="md"
      header-bg-variant="info"
      header-text-variant="light"
    )
      p.mb-2 {{ $t("ui.password_rules_intro") }}
      ul.mb-0
        li {{ $t("message.password_length_error") }}
        li {{ $t("message.password_whitespace_error") }}
        li {{ $t("message.password_types_error") }}
        li {{ $t("message.password_consecutive_error") }}
        li {{ $t("message.password_repeated_error") }}
        li {{ $t("message.password_common_error") }}
</template>

<script>
export default {
  name: "PasswordRules",
  props: {
    buttonStyle: {
      type: String,
      default:
        "border-top-left-radius: 0;border-bottom-left-radius: 0;border-top-right-radius: 3px;border-bottom-right-radius: 3px;"
    }
  },
  data() {
    return {
      show: false
    };
  }
};
</script>